import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Header from './shared-components/Header';
import Footer from './shared-components/Footer';

import ScrollToTop from './ScrollToTop';

import Home from './components/Home/Home';
import AboutUs from './components/AboutUs/AboutUs';
import MissionAchievements from './components/AboutUs/MissionAchievements';
import CompanyInfrastructure from './components/AboutUs/CompanyInfrastructure';
import ContactUs from './components/ContactUs/ContactUs';
import Products from './components/Products/Products';

function App() {
  return (
    <>
      <Router>
        <Header />
        <ScrollToTop />
        <Routes>
          
          {/* <Route index Component={Home} />
          <Route path="aboutus" Component={AboutUs} />
          <Route path="infrastructure" Component={CompanyInfrastructure} />
          <Route path="mission-achievements" Component={MissionAchievements} />
          <Route path="products" Component={Products} />
          <Route path="contactus" Component={ContactUs} /> */}

          <Route index element={<Home />} />
          <Route path="aboutus" element={<AboutUs />} />
          <Route path="infrastructure" element={<CompanyInfrastructure />} />
          <Route path="mission-achievements" element={<MissionAchievements />} />
          <Route path="products" element={<Products />} />
          <Route path="contactus" element={<ContactUs />} />

        </Routes>
        <Footer />
      </Router>
    </>
  );
}

export default App;
